import React from 'react';
import EcommerceHero from '../components/EcommerceHero';
import Counters from '../components/Counters';
import EcommerceConversionSolutions from '../components/EcommerceConversionSolutions';
import EcommerceServicesGrid from '../components/EcommerceServicesGrid';
import EcommercePortfolio from '../components/EcommercePortfolio';
import EcommerceKarachiPakistanSection from '../components/EcommerceKarachiPakistanSection';
import EcommerceProcessSteps from '../components/EcommerceProcessSteps';
import WhyChooseEcommerce from '../components/WhyChooseEcommerce';
import EcommerceQualityExperience from '../components/EcommerceQualityExperience';
import EcommerceTestimonialsSlider from '../components/EcommerceTestimonialsSlider';
import IndustryGrid from '../components/IndustryGrid';
import ContactUs from '../components/ContactUs';

const storesIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <path d="M16 10a4 4 0 0 1-8 0" />
  </svg>
);

const growthIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

const experienceIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6" />
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
  </svg>
);

const satisfactionIcon = (
  <svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#c40a0a" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <path d="M8 14s1.5 2 4 2 4-2 4-2" />
    <line x1="9" y1="9" x2="9.01" y2="9" />
    <line x1="15" y1="9" x2="15.01" y2="9" />
  </svg>
);

const ecommerceCountersData = [
  { target: 500, suffix: '+', text: 'Stores Launched', icon: storesIcon },
  { target: 98, suffix: '%', text: 'Conversion Uplift', icon: growthIcon },
  { target: 9, suffix: '+', text: 'Years of Experience', icon: experienceIcon },
  { target: 100, suffix: '%', text: 'Client Satisfaction', icon: satisfactionIcon }
];

function EcommerceWebDevPage() {
  return (
    <>
      <EcommerceHero />
      <Counters data={ecommerceCountersData} />
      <EcommerceConversionSolutions />
      <EcommerceServicesGrid />
      <EcommercePortfolio />
      <EcommerceKarachiPakistanSection />
      <EcommerceProcessSteps />
      <WhyChooseEcommerce />
      <EcommerceQualityExperience />
      <IndustryGrid />
      <EcommerceTestimonialsSlider />
      <ContactUs />
    </>
  );
}

export default EcommerceWebDevPage;
